export class TabPanels extends HTMLElement {
  connectedCallback() {
    const selectors = {
      tab: '[role="tab"]',
      panelWrapper: ".tab-panel__panels",
      panel: '[role="tabpanel"]',
    };

    const classes = {
      tabActive: "button-active",
      panelActive: "panel-active",
    };

    const root = document.documentElement;
    const panelHeight = this.querySelector(selectors.panel).clientHeight;

    const initialTabWidth = this.querySelector(
      `.${classes.tabActive}`
    ).clientWidth;
    const initialTabPosition = this.querySelector(
      `.${classes.tabActive}`
    ).offsetLeft;
    root.style.setProperty("--tab-bar-position", `${initialTabPosition}px`);
    root.style.setProperty("--tab-bar-width", `${initialTabWidth}px`);

    this.querySelector(
      selectors.panelWrapper
    ).style.height = `${panelHeight}px`;

    this.querySelectorAll(selectors.tab).forEach((tab) => {
      tab.addEventListener("click", (evt) => {
        const panelId = tab.getAttribute("aria-controls");
        const tabId = tab.getAttribute("id");
        const event = new CustomEvent("panel:switch", {
          detail: {
            panelId,
          },
          bubbles: true,
          composed: true,
        });
        evt.target.dispatchEvent(event);
        const newPanelHeight = document.getElementById(panelId).clientHeight;
        document.querySelector(
          selectors.panelWrapper
        ).style.height = `${newPanelHeight}px`;
        const tabItemWidth = tab.clientWidth;
        const tabItemPosition = tab.offsetLeft;
        root.style.setProperty("--tab-bar-position", `${tabItemPosition}px`);
        root.style.setProperty("--tab-bar-width", `${tabItemWidth}px`);
        tab.classList.add("button-active");
        tab.setAttribute("aria-selected", "true");
        this.querySelectorAll(`${selectors.tab}:not(#${tabId})`).forEach(
          (inactiveTab) => {
            inactiveTab.classList.remove("button-active");
            inactiveTab.setAttribute("aria-selected", "false");
          }
        );
      });
    });

    this.addEventListener("panel:switch", (evt) => {
      const panelId = evt.detail.panelId;
      const panel = document.getElementById(`${panelId}`);
      panel.classList.add("panel-active");
      panel.tabindex = 1;
      this.querySelectorAll(`${selectors.panel}:not(#${panelId})`).forEach(
        (inactivePanel) => {
          inactivePanel.tabindex = -1;
          inactivePanel.classList.remove("panel-active");
        }
      );
    });
  }
}

customElements.define("tab-panel", TabPanels);
